/**
 * @readonly
 * @constant
 * @enum {string}
 */
export const DatasetTypes = {
  /**@default "tabular" */
  TABULAR: "tabular",

  /**@default "image" */
  IMAGE: "image",

  /**@default "quality-check" */
  QUALITY_CHECK: "quality-check",

  /**@default "unsupervised-image" */
  UNSUPERVISED_IMAGE: "unsupervised-image",

  /**@default "default" */
  DEFAULT: "default",
};
